import { useState } from "react";
import { ListThreadsRequest, useListThreadUsers } from "duck/endpoints/threads";
import { useTranslation } from "react-i18next";

import { useEmailFromJWT } from "shared/hooks";

import { DropdownSelectOption } from "features/ui/DropdownSelect/DropdownSelect";
import Select from "features/ui/Select";

interface Props {
  setThreadListArguments: (args: ListThreadsRequest) => void;
  useListThreadArgs: ListThreadsRequest;
}

const getPickedOptionFromArgs = (
  { all_users, user_filter }: ListThreadsRequest,
  meOption: DropdownSelectOption,
  allUsersOption: DropdownSelectOption
) => {
  if (!all_users) {
    return meOption;
  } else if (user_filter) {
    return { id: user_filter, value: user_filter };
  } else {
    return allUsersOption;
  }
};

const SelectThreadUser = ({
  setThreadListArguments,
  useListThreadArgs,
}: Props) => {
  const { t } = useTranslation("duck");
  const { data } = useListThreadUsers();

  const currentUserEmail = useEmailFromJWT();

  const allUsersOption = {
    id: "all_users",
    value: t("all_users"),
  };

  const meOption = {
    id: currentUserEmail,
    value: t("me"),
  };

  const options: DropdownSelectOption[] = [
    meOption,
    allUsersOption,
    ...(data?.users || [])
      ?.filter((user) => user !== meOption.id)
      .map((user) => ({
        id: user,
        value: user,
      })),
  ];

  const pickedOptionFromArgs = getPickedOptionFromArgs(
    useListThreadArgs,
    meOption,
    allUsersOption
  );

  const [selectedOption, setSelectedOption] =
    useState<DropdownSelectOption>(pickedOptionFromArgs);

  return (
    <div className="px-2 pt-2">
      <Select
        options={options}
        selected={selectedOption}
        label={t("user")}
        fullWidth
        onSelect={(option) => {
          setSelectedOption(option);
          if (option.id === meOption.id) {
            setThreadListArguments({});
          } else if (option.id === allUsersOption.id) {
            setThreadListArguments({ all_users: true });
          } else if (option.id) {
            setThreadListArguments({
              all_users: true,
              user_filter: option.id as string,
            });
          }
        }}
      />
    </div>
  );
};

export default SelectThreadUser;
